<template>
  <hm-content title="新增项目">
    <el-form :model="ruleForm"
             :rules="rules"
             class="product-ruleForm"
             ref="ruleForm"
             label-width="100px">
      <!-- <el-form-item label="选择门店："
                    prop="storeOutletIds">
        <div>
          <el-select v-model="ruleForm.storeOutletIds"
                     placeholder="选择门店可多选"
                     size="small"
                     multiple
                     filterable>
            <el-option v-for="item in storeList.list"
                       :key="item.value"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </div>
      </el-form-item> -->
      <el-form-item label="服务分类："
                    prop="serviceCategoryId">
        <el-select clearable
                   v-model="ruleForm.serviceCategoryId"
                   placeholder="选择分类"
                   size="small"
                   filterable
                   class="mr10">
          <el-option v-for="item in serviceCategoryList.list"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称："
                    prop="name">
        <el-input size="small"
                  class="mr10 ipt"
                  clearable
                  v-model.trim="ruleForm.name"
                  placeholder="请输入项目名称"></el-input>
      </el-form-item>
      <el-form-item label="项目标签：">
        <el-tag :key="i"
                v-for="(tag, i) in ruleForm.serverTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">{{tag}}</el-tag>
        <el-input class="input-new-tag"
                  v-if="inputVisible"
                  v-model.trim="inputValue"
                  ref="saveTagInput"
                  size="small"
                  clearable
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"></el-input>
        <el-button v-else
                   class="button-new-tag"
                   size="small"
                   @click="showInput">+ 新标签</el-button>
      </el-form-item>
      <!-- <el-form-item label="有效期："
                    prop="validityPeriod"
                    ref="period">
        <el-radio-group v-model="ruleForm.validateType">
          <el-radio :label="1">固定时长</el-radio>
          <el-radio :label="2">自定义日期</el-radio>
          <el-radio :label="0">不限</el-radio>
        </el-radio-group>
        <div v-show="ruleForm.validateType === 1">自激活后生效，有效期
          <el-input size="small"
                    v-model.trim="ruleForm.validateDay"
                    class="mr10 ipt"></el-input>天（N个月，按每月30天计算）
        </div>
        <div v-show="ruleForm.validateType === 2">
          <el-date-picker v-model="ruleForm.dateAndTime"
                          type="daterange"
                          size="small"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"></el-date-picker>
        </div>
      </el-form-item> -->
      <el-form-item label="主图："
                    prop="listHeader">
        <!-- 主图 -->
        <my-upload field="file"
                   @crop-success="cropSuccess"
                   @crop-upload-success="cropUploadSuccess"
                   @crop-upload-fail="cropUploadFail"
                   v-model="show"
                   noCircle
                   noSquare
                   :width="345"
                   :headers="{'X-Access-Token': $token}"
                   :params="{  fileDir: 'mall'  }"
                   :url="$uploadUrl"
                   :height="180"
                   img-format="png"></my-upload>
        <el-button type="primary"
                   size="small"
                   v-show="!listHeaderImgUrl"
                   @click="toggleShow">上传</el-button>

        <span class="form-tip">（主图仅可设置一张，图片尺寸建议345x180）</span>
        <div class="priview"
             v-show="listHeaderImgUrl">
          <img :src="listHeaderImgUrl"
               alt="主图">
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button type="text"
                       @click="deleteListHeader">删除</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="轮播组图："
                    prop="listDetail">
        <my-upload field="file"
                   @crop-success="cropSuccess"
                   @crop-upload-success="cropUploadSuccess"
                   @crop-upload-fail="cropUploadFail"
                   v-model="showDetail"
                   noCircle
                   noSquare
                   :width="345"
                   :height="180"
                   :headers="{'X-Access-Token': $token}"
                   :params="{  fileDir: 'mall'  }"
                   :url="$uploadUrl"
                   img-format="png"></my-upload>
        <el-button type="primary"
                   size="small"
                   v-show="uploadedDetailList.length < 6"
                   @click="toggleShowDetail">上传</el-button>
        <span class="form-tip">（列表详情图可设置6张，图片尺寸建议345x180）</span>
        <ul class="flex flex-wrap">
          <li class="priview mr10"
              v-show="v"
              v-for="(v, i) in uploadedDetailList"
              :key="i">
            <img :src="v"
                 alt="列表详情图">
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text"
                         @click="setFirst(i)">设为第一张图</el-button>
              <el-button type="text"
                         @click="deleteListItem(i)">删除</el-button>
            </div>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="图文详情："
                    prop="imgTxt">
        <hm-rich-editor v-model="ruleForm.imgTxt" />
      </el-form-item>
      <el-form-item label="项目状态：">
        <div class="flex item-center">
          <el-switch style="display: block"
                     v-model="ruleForm.status"
            active-color="#13ce66"
                     inactive-color="#ff4949"
                     active-text="开启"
                     inactive-text="关闭"
                     :active-value="1"
                     :inactive-value="0"></el-switch>
          <span class="form-tip">（关闭后，不出现在项目内）</span>
        </div>
      </el-form-item>
      <!-- <el-form-item label="计费方式：">
        <el-radio-group v-model="ruleForm.chargeType">
          <el-radio :label="0">按次计费</el-radio>
          <el-radio :label="1">按时计费</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <!-- <el-form-item label="预约用卡：">
        <el-radio-group v-model="ruleForm.useCardType">
          <el-radio :label="0">用卡</el-radio>
          <el-radio :label="1">不用卡</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="提醒："
                    prop="isRemind">
        <el-select v-model="ruleForm.isRemind"
                   placeholder="是否提醒"
                   size="small"
                   filterable>
          <el-option v-for="item in remindList"
                     :key="item.value"
                     :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
        <span class="form-tip">(提醒方式为短信提醒,接近预约时间时提前多长时间提醒客户)</span>
      </el-form-item>
      <el-form-item label="预约提前天数："
                    prop="maxEndTime">
        <el-select v-model="ruleForm.maxEndTime"
                   placeholder="选择可提前预约天数"
                   size="small"
                   filterable>
          <el-option v-for="item in endTimeList"
                     :key="item.value"
                     :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
        <span class="form-tip">(可被预约的最长日期，例如：设置7天，客户只能选择7天可预约日期，其他时间不可被预约)</span>
      </el-form-item>
      <el-form-item label="提前预约时间："
                    prop="preOrderTime">
        <el-select v-model="ruleForm.preOrderTime"
                   placeholder="选择可提前预约天数"
                   size="small"
                   filterable>
          <el-option v-for="item in preOrderTimeList"
                     :key="item.value"
                     :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
        <span class="form-tip">(在选择设置时间后预约，例如：现在9:00，选择提前预约时间为1小时，在客户预约选择时间时只能预约10点之后的时间)</span>
      </el-form-item>
      <el-form-item label="项目服务时间："
                    prop="serverTime">
        <div class="flex">
          <div class="flex">
            <el-input size="small"
                      class="ipt mr10"
                      style="width: 100px;"
                      clearable
                      type="number"
                      v-model.trim="ruleForm.serverTime"
                      placeholder="间隔时间"></el-input>
            分
            <!-- <el-select v-model="timeType"
                       class="time-type"
                       type="number"
                       placeholder="选择可提前预约天数"
                       size="small"
                       filterable>
              <el-option label="分钟"
                         value="0"></el-option>
              <el-option label="小时"
                         value="1"></el-option>
            </el-select> -->
          </div>
          <span class="form-tip">(时间间隔设置影响小程序预约时间，预约时间=技师排班时间+时间间隔)</span>
        </div>
      </el-form-item>

      <el-form-item label="项目说明：">
        <el-input size="small"
                  type="textarea"
                  clearable
                  v-model.trim="ruleForm.description"
                  placeholder="请输入项目说明"></el-input>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary"
                   size="small"
                   @click="submitForm('ruleForm')">提交</el-button>
        <el-button size="small"
                   @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
    <div id="dragContainer">
      <div class="preview-wrapper"
           id="dragbleElement">
        <div class="flex flex-center">
          <el-button size="small"
                     :type="isMininum ? 'danger' : 'danger'"
                     round
                     @click="minimum">
            <span>{{isMininum ? '点击预览' : '点击隐藏'}}</span>
          </el-button>
        </div>
        <transition name="fade">
          <div class="coupon-template"
               v-show="!isMininum">
            <div class="phone-container">
              <div class="phone-header flex-center flex item-center">
                项目详情
                <div class="setting flex">
                  <span class="hmicon icon-xuanxiang"></span>
                  <span class="hmicon icon-option_on"></span>
                </div>
              </div>
              <div class="phone-body">
                <div class="tabs flex flex-around">
                  <div class="tab"
                       :class="{active: activeTab === 0}"
                       @click="activeTab = 0">项目</div>
                  <div class="tab"
                       :class="{active: activeTab === 1}"
                       @click="activeTab = 1">详情</div>
                </div>
                <div v-show="activeTab === 0">
                  <el-carousel height="173px">
                    <el-carousel-item v-for="(v, i) in uploadedDetailList"
                                      :key="i">
                      <div class="img-wrapper">
                        <img :src="v"
                             alt="列表详情图">
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                  <div class="goods-info p10">
                    <div class="flex flex-between">
                      <div class="goods-name title">{{ruleForm.name || '项目名'}}</div>
                      <!-- <div class="goods-price danger">￥{{ruleForm.price || '项目卡价格'}}</div> -->
                    </div>
                    <div class="productTags flex flex-wrap">
                      <div class="tag"
                           v-for="(v, i) in ruleForm.serverTags"
                           :key="i">{{v}}</div>
                      <div v-show="!ruleForm.serverTags.length">标签</div>
                    </div>
                  </div>
                  <!-- <div class="goods-details p10 detail">
                     <div>
                      项目规格： <span class="tag">{{ruleForm.specification || '规格'}}</span>
                    </div><div>
                      项目有效期：
                      <span v-if="ruleForm.validType === 0">不限时间</span>
                      <span v-else-if="ruleForm.validType === 2">{{startDate || moment(ruleForm.dateAndTime[0]).format('YYYY-MM-DD')}}至{{endDate || moment(ruleForm.dateAndTime[1]).format('YYYY-MM-DD')}}</span>
                      <span v-else-if="ruleForm.validType === 1">购买后{{ruleForm.validSpaceDay}}天后生效，有效期{{ruleForm.validDay}}天</span>
                    </div>
                  </div> -->
                  <div class="container imgTxt p10">
                    <div class="text-center title">图文详情</div>
                    <div class="ql-container ql-snow">
                      <div class="ql-editor">
                        <div v-html="ruleForm.imgTxt"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="activeTab === 1">
                  <div class="ql-container ql-snow">
                    <div class="ql-editor">
                      <div v-html="ruleForm.imgTxt"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </hm-content>
</template>

<script>
 
 import HmRichEditor from "@/components/HmRichEditor";
import { drag } from "@/utils/utils";
import { mapGetters } from "vuex";
import moment from "moment";
import { getLoginUser } from "@/utils/auth";
import myUpload from "vue-image-crop-upload";

export default {
  components: {   HmRichEditor, myUpload },
  data () {
    const patternvalidityPeriod = function (rule, val, callback) {
      if (
        this.ruleForm.validateType === 1 &&
        (!this.ruleForm.validateDay || this.ruleForm.validateDay <= 0)
      ) {
        return callback(new Error("请输入有效期，且应大于0"));
      } else if (
        this.ruleForm.validateType === 2 &&
        (!this.ruleForm.dateAndTime || !this.ruleForm.dateAndTime.length)
      ) {
        return callback(new Error("请输入有效期"));
      } else {
        callback();
      }
    }.bind(this);
    const patternListHeader = function (rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请上传主图"));
      }
      callback();
    }.bind(this);
    const patternListDetail = function (rule, val, callback) {
      if (this.uploadedDetailList.length <= 0) {
        return callback(new Error("请上传列表详情图"));
      }
      callback();
    }.bind(this);
    const patternServerTime = function (rule, val, callback) {
      if (val >= 15 && Number.isInteger(+val)) {
        callback();
      } else {
        return callback(new Error("请输入大于或等于15的整数"));
      }
    }.bind(this);
    return {
      remindList: [
        {
          name: "不提醒",
          value: 0
        },
        {
          name: "3小时前",
          value: 3
        },
        {
          name: "4小时前",
          value: 4
        },
        {
          name: "5小时前",
          value: 5
        },
        {
          name: "6小时前",
          value: 6
        },
        {
          name: "7小时前",
          value: 7
        },
        {
          name: "8小时前",
          value: 8
        },
        {
          name: "1天前",
          value: 24
        }
      ],
      endTimeList: [
        {
          name: "7天",
          value: 7
        },
        {
          name: "10天",
          value: 10
        },
        {
          name: "15天",
          value: 15
        },
        {
          name: "30天",
          value: 30
        }
      ],
      preOrderTimeList: [],
      serviceTime: [
        {
          name: "每10分钟",
          value: 10
        },
        {
          name: "每20分钟",
          value: 20
        },
        {
          name: "每30分钟",
          value: 30
        },
        {
          name: "每1小时",
          value: 60
        },
        {
          name: "每2小时",
          value: 120
        },
        {
          name: "每3小时",
          value: 180
        }
      ],
      showDetail: false,
      show: false,
      activeTab: 0,
      status: 1,
      inputVisible: false,
      isMininum: true,
      inputValue: "",
      type: 0,
      uploadedDetailList: [],
      listHeaderImgUrl: "",
      storeId: "",
      startDate: "",
      endDate: "",
      editorOption: {},
      timeType: "0",
      ruleForm: {
        name: "",
        // storeOutletIds: [],
        chargeType: 0,
        useCardType: 0,
        status: 1,
        serverTags: [],
        description: "",
        validateType: 1,
        validateDay: "",
        dateAndTime: "",
        imgTxt: "",
        isRemind: 3,
        maxEndTime: 7,
        preOrderTime: 1,
        serverTime: 30,
        serviceCategoryId: ""
      },
      rules: {
        serviceCategoryId: {
          required: true,
          message: "请选择服务分类",
          trigger: "change"
        },
        serverTime: [
          {
            required: true,
            message: "请输入项目服务时间",
            trigger: "blur"
          },
          {
            trigger: "blur",
            validator: patternServerTime
          }
        ],
        // storeOutletIds: {
        //   required: true,
        //   message: "请选择门店",
        //   trigger: "change"
        // },
        isRemind: {
          required: true,
          message: "请选择是否提醒",
          trigger: "change"
        },
        preOrderTime: {
          required: true,
          message: "请选择提前预约时间",
          trigger: "blur"
        },
        maxEndTime: {
          required: true,
          message: "请选择可提前预约天数",
          trigger: "change"
        },
        imgTxt: [
          { required: true, message: "请输入图文详情", trigger: "blur" }
        ],
        name: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
          { max: 15, message: "长度应小于15个字", trigger: "blur" }
        ],
        validityPeriod: [
          {
            required: true,
            validator: patternvalidityPeriod,
            trigger: "blur"
          }
        ],
        listHeader: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur"
          }
        ],
        listDetail: [
          {
            required: true,
            validator: patternListDetail,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: mapGetters(["storeList", "serviceCategoryList"]),
  watch: {
    "ruleForm.validateType": {
      handler (v) {
        this.$refs.period.clearValidate();
        if (v === 1) {
          this.ruleForm.dateAndTime = "";
        } else if (v === 2) {
          this.ruleForm.validateDay = "";
        }
      },
      deep: true
    },
    "ruleForm.dateAndTime": {
      handler (val) {
        this.startDate = val ? moment(val[0]).format("YYYY-MM-DD") : "";
        this.endDate = val ? moment(val[1]).format("YYYY-MM-DD") : "";
      },
      deep: true
    }
  },
  mounted () {
    for (let index = 1; index < 12; index++) {
      this.preOrderTimeList.push({
        name: index + "小时",
        value: index
      });
    }
    this.preOrderTimeList.push(
      {
        name: 24 + "小时",
        value: 24
      },
      {
        name: "不限制",
        value: 0
      }
    );
    const { storeId } = getLoginUser();
    this.storeId = storeId;
    const dragbleElement = document.getElementById("dragbleElement");
    const dragContainer = document.getElementById("dragContainer");
    drag.startDrag(dragContainer, dragbleElement);
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
    this.$store.dispatch("queryServiceCategoryList", {
      pageSize: 999
    });
  },
  methods: {
    toggleShow () {
      this.show = !this.show;
    },
    toggleShowDetail () {
      this.showDetail = !this.showDetail;
    },
    cropSuccess () {
    },
    /**
     * upload success
     *
     * [param] jsonData   项目器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess (jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    // cropUploadDetailsSuccess(jsonData) {
    //   this.uploadedDetailList.push(jsonData.result);
    // },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail () {
    },
    minimum () {
      this.isMininum = !this.isMininum;
    },
    showInput () {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose (tag) {
      this.ruleForm.serverTags.splice(this.ruleForm.serverTags.indexOf(tag), 1);
    },
    handleInputConfirm () {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.serverTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params = Object.assign(params, {
            detailImg: this.uploadedDetailList.join(","),
            listImg: this.listHeaderImgUrl
            // validateStartDate:
            //   this.ruleForm.validateType === 2 ? this.startDate : "",
            // validateEndDate:
            //   this.ruleForm.validateType === 2 ? this.endDate : ""
          });
          this.$store.dispatch("addService", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove () {
      this.listHeaderImgUrl = "";
    },
    deleteListHeader () {
      this.listHeaderImgUrl = "";
    },
    // 上传成功后的回调
    uploadSuccess (response) {
      this.listHeaderImgUrl = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    // 上传错误
    uploadError () {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    // 上传前对文件的大小的判断
    beforeUpload (file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 300;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 300k!",
          type: "warning"
        });
      }
      const isSize = new Promise((resolve, reject) => {
        let width = 345;
        let height = 180;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "请上传345*180的图片!",
            type: "warning"
          });
          return Promise.reject();
        }
      );
      return (
        (extension || extension2 || extension3 || extension4) &&
        limitSize &&
        isSize
      );
    },
    handleRemoveListDetail (file) {
      if (typeof file === "number") {
        this.uploadedDetailList.splice(file, 1);
      } else {
        const index = this.uploadedDetailList.findIndex(
          v => v === file.response.result
        );
        this.uploadedDetailList.splice(index, 1);
      }
    },
    uploadListDetailError () {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadListDetailSuccess (response) {
      this.uploadedDetailList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    deleteListItem (i) {
      this.uploadedDetailList.splice(i, 1);
      // this.$refs.listDetailUpload.handleRemove(i);
    },
    setFirst (i) {
      let tmp = this.uploadedDetailList[0];
      this.uploadedDetailList[0] = this.uploadedDetailList[i];
      this.uploadedDetailList[i] = tmp;
      this.$forceUpdate();
    }
  }
};
</script>
<style lang="scss">
.main-container {
  .time-type {
    .el-input {
      width: 100px;
    }
  }
}
</style>

<style scoped lang="scss">
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.priview {
  position: relative;
  width: 345px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;
}
</style>
